import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M22 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M22 24.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
    />
  </svg>
);
const SvgIconDotsSixVertical = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDotsSixVertical);
export default Memo;
